export default __webpack_public_path__ + "static/media/evening.2b709d87.jpg";